import nxModule from 'nxModule';
import StatusBasedService from "./statusBasedService";

nxModule.factory('cashTransferCheckService', (statusService) =>
  new StatusBasedService({
    property: 'waitForCashTransfer',
    statusService: statusService,
    defaultIfEmpty: false
  }));
